/*
 * @Author: Dong
 * @Date: 2022-04-16 16:40:46
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-05-08 09:49:41
 */
import messages from './messages';

// 1 安装 2 升级 3卸载
export const typeObj = ['', 'install', 'upgrade', 'uninstall', '', '', 'upgrade', 'rollBack'];
// 0 等待 1 解压中 2 安装中 3 成功 4 失败
export const statusObj = ['waiting', 'doing', 'doing', 'success', 'failure'];

export const failStatus: { [x: string]: any } = {
  install: messages.failedInstall,
  upgrade: messages.failedUpgrade,
  uninstall: messages.failedUninstall,
  rollBack: messages.failedRollBack,
};

export const doingStatus: { [x: string]: any } = {
  install: messages.installing,
  upgrade: messages.upgrading,
  uninstall: messages.uninstalling,
  rollBack: messages.rolling_back,
};

export const successStatus: { [x: string]: any } = {
  install: messages.successInstall,
  upgrade: messages.successUpgrade,
};

export const strokeColors: { [x: string]: string } = {
  doing: '#2280fa',
  success: '#2280fa',
  failure: '#d20c0c',
};

export const doingIcons: { [x: string]: string } = {
  install: 'installing16',
  upgrade: 'upgrading20',
  uninstall: 'uninstall20',
};

export const doneStatus: { [x: string]: string } = {
  install: 'installing16',
  upgrade: 'upgrading20',
  uninstall: 'uninstall20',
};
